const LAST_RECOVERY_KEY = 'puttzin_last_chunk_recovery_ms'
/** At most one automatic full reload in this window (stops infinite failure loops) */
const COOLDOWN_MS = 90_000

/**
 * Vite + SPA deploy: cached index.html can reference old hashed chunks; a request
 * for a missing /assets/*.js can fall back to index.html and produce:
 *   TypeError: 'text/html' is not a valid JavaScript MIME type
 * or dynamic import "Failed to fetch" errors.
 * One hard reload fetches a fresh index with current chunk names.
 * Register before React lazy routes and before Sentry so early failures are caught.
 */
export function installChunkLoadRecovery() {
  const shouldHandle = (msg) => {
    if (!msg) return false
    const s = String(msg)
    if (/not a valid JavaScript MIME type|text\/html is not a valid.*MIME/i.test(s)) {
      return true
    }
    if (
      /Failed to fetch dynamically imported module|dynamically imported module|Importing a module script failed/i.test(
        s
      )
    ) {
      return true
    }
    if (/\bLoading chunk \d+ failed\b/i.test(s) || (s.includes('Failed to') && s.includes('import'))) {
      return true
    }
    return false
  }

  const tryRecover = (detail) => {
    if (typeof document === 'undefined' || !document.body) {
      return
    }
    let last = 0
    try {
      const raw = sessionStorage.getItem(LAST_RECOVERY_KEY)
      last = raw ? parseInt(raw, 10) : 0
    } catch {
      // ignore
    }
    if (Number.isFinite(last) && last > 0 && Date.now() - last < COOLDOWN_MS) {
      return
    }
    try {
      sessionStorage.setItem(LAST_RECOVERY_KEY, String(Date.now()))
    } catch {
      // still try reload
    }
    if (import.meta.env.DEV) {
      // eslint-disable-next-line no-console
      console.warn('[chunkLoadRecovery] Stale or missing Vite chunk — reloading', detail)
    }
    window.location.reload()
  }

  const onRejection = (e) => {
    const r = e.reason
    const msg = r && typeof r === 'object' && r.message != null ? r.message : r
    if (shouldHandle(msg) || (typeof r === 'string' && shouldHandle(r))) {
      e.preventDefault()
      tryRecover('unhandledrejection')
    }
  }

  window.addEventListener('unhandledrejection', onRejection)
}
